import styled from 'styled-components';

export const BadgeColorBox = styled.div`
  max-width: 348px;
  background: #fff;
  padding: 20px;
  box-shadow: 0px 20px 20px #0000001A;
  border-radius: 15px;

  &.base-color{
    display: none;
  }
`;

export const BadgeColorBoxTitle = styled.h4`
  color: #333333;
  font-size: 20px;
  font-family: "Jost", sans-serif;
  font-weight:600;
  line-height: 30px;
`;

export const BadgeCheckBoxWrap = styled.div`
  margin-top: 10px;
`;

export const BadgeCheckForm = styled.form`

  .badge-color-box-radio {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 15px;
  }

  label{
    color: #333333;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 20px;
    padding-left: 5px;
    padding-right: 0;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
  }

  .form-check-inline{
    margin-right: 0px;
    position: relative;
    cursor: pointer;

    &.orange{
      .form-check-input{
        background: #F7931E;
        border: #F7931E;
      }
    }

    &.green{
      .form-check-input{
      background: #34A853;
      border: #34A853;
      }
    }
    &.gray{
      .form-check-input{
      background: #BABABA;
      border: #BABABA;
      }
    }

    &.blue{
      .form-check-input{
      background: #33A7AE;
      border: #33A7AE;
      }
    }

    .form-check-input{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      cursor: pointer;
  
      &:checked {
        background-size: 16px;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="64" height="64"><path d="M0 0 C0.85205078 2.1003418 0.85205078 2.1003418 1 5 C-0.80325294 7.40324577 -2.50090052 9.3187865 -4.6328125 11.39453125 C-5.22166229 11.98674973 -5.81051208 12.5789682 -6.41720581 13.18913269 C-7.66605247 14.43768038 -8.92239781 15.67876572 -10.18554688 16.9128418 C-12.11628512 18.80396394 -14.01603216 20.72259867 -15.9140625 22.64648438 C-17.13106554 23.85592709 -18.3497619 25.06366877 -19.5703125 26.26953125 C-20.13823517 26.84443802 -20.70615784 27.41934479 -21.29129028 28.01167297 C-23.67403368 30.3111557 -25.38523675 31.87635232 -28.67773438 32.53857422 C-32.96271847 31.54481109 -35.38439865 28.37343246 -38.375 25.3125 C-39.35533203 24.37374023 -39.35533203 24.37374023 -40.35546875 23.41601562 C-42.08640997 21.67596419 -43.63883114 20.04290977 -45 18 C-44.9140625 15.04296875 -44.9140625 15.04296875 -44 13 C-42.25 12.296875 -42.25 12.296875 -40 12 C-38 13.328125 -38 13.328125 -36 15.25 C-33.42538131 17.68381923 -30.85072639 19.89610453 -28 22 C-27.36497559 21.33355469 -26.72995117 20.66710937 -26.07568359 19.98046875 C-23.70591971 17.50827298 -21.32308346 15.05030529 -18.93017578 12.60058594 C-17.89859451 11.53888314 -16.87246862 10.47185064 -15.85205078 9.39941406 C-14.3816479 7.85599215 -12.89249494 6.33299233 -11.3984375 4.8125 C-10.50817871 3.89082031 -9.61791992 2.96914063 -8.70068359 2.01953125 C-5.51430867 -0.36319279 -3.88711903 -0.43910972 0 0 Z " fill="%23FFFFFF" transform="translate(54,16)"/></svg>');  
      }
  
      &:focus{
        border-color: transparent;
        outline: 0;
        box-shadow: none;
      }
      
    }
  }
`;

export const RadioBox = styled.div`

`;

export const BadgeCheckBoxMain = styled.div`

`;